import { FC, useEffect, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { postChancePointCollisionCheck } from '@/common/api/expandStore/chancepoint';
import { ControlType, hasAreaProtectionAndAddress, parseValueCatch } from '@/common/components/business/DynamicComponent/config';
import { addressIdentification } from '@/common/components/business/DynamicComponent/customize';
import { adaptCollisionCheckResult, AreaProtectionResult, CollisionCheckGroup, shouldPersistSpecialApplication } from '@/common/components/business/DynamicComponent/components/AreaProtection/collision';
import AreaProtectionPanel from '@/common/components/business/DynamicComponent/components/AreaProtection/AreaProtectionPanel';
import { Col } from 'antd';

const AreaProtectionDetail: FC<{
  textValue: any;
  allComponents: any[];
  chancePointId?: number | null;
  onCollisionChange?: (hasCollisionWithin200m: boolean | undefined) => void;
}> = ({ textValue, allComponents, chancePointId, onCollisionChange }) => {
  const persistedGroups: CollisionCheckGroup[] = Array.isArray(textValue?.groups) ? textValue.groups : [];
  const hasInitiatedApplication = shouldPersistSpecialApplication(textValue?.approvalStatus, persistedGroups);
  const [result, setResult] = useState<AreaProtectionResult | undefined>(hasInitiatedApplication ? adaptCollisionCheckResult(persistedGroups) : undefined);
  const [isLoading, setIsLoading] = useState(!hasInitiatedApplication);
  const requestIdRef = useRef(0);
  const hasAreaProtection = hasAreaProtectionAndAddress(allComponents);
  const addressComponent = Array.isArray(allComponents) ? allComponents.find((item: any) => item.identification === addressIdentification || item.controlType === ControlType.ADDRESS.value) : null;
  const addressValue = addressComponent ? parseValueCatch(addressComponent) : null;
  const longitude = addressValue?.longitude === null || addressValue?.longitude === undefined || addressValue?.longitude === '' ? NaN : Number(addressValue.longitude);
  const latitude = addressValue?.latitude === null || addressValue?.latitude === undefined || addressValue?.latitude === '' ? NaN : Number(addressValue.latitude);
  const methods = useMethods({
    queryCollision() {
      if (!hasAreaProtection) return;
      if (hasInitiatedApplication) {
        const adaptedResult = adaptCollisionCheckResult(persistedGroups);
        setResult(adaptedResult);
        onCollisionChange?.(adaptedResult.allowApply);
        setIsLoading(false);
        return;
      }
      if (!Number.isFinite(longitude) || !Number.isFinite(latitude)) {
        setResult(undefined);
        onCollisionChange?.(undefined);
        setIsLoading(false);
        return;
      }
      const requestId = requestIdRef.current + 1;
      requestIdRef.current = requestId;
      setIsLoading(true);
      onCollisionChange?.(undefined);
      postChancePointCollisionCheck({ lng: longitude, lat: latitude, chancePointId: chancePointId ?? null }).then((data: any) => {
        if (requestId === requestIdRef.current) {
          const adaptedResult = adaptCollisionCheckResult(Array.isArray(data?.groups) ? data.groups : []);
          setResult(adaptedResult);
          onCollisionChange?.(adaptedResult.allowApply);
        }
      }, (error) => {
        console.log('详情查询区域保护防撞店失败', error);
        if (requestId === requestIdRef.current) {
          setResult(undefined);
          onCollisionChange?.(undefined);
        }
      }).finally(() => {
        if (requestId === requestIdRef.current) {
          setIsLoading(false);
        }
      });
    },
  });
  useEffect(methods.queryCollision, [longitude, latitude, hasInitiatedApplication, hasAreaProtection]);

  return hasAreaProtection ? <Col span={24} className={'mt-10'}>
    <AreaProtectionPanel
      result={result}
      isLoading={isLoading}
    />
  </Col> : null;
};

export default AreaProtectionDetail;
